import testmoni1 from "public/static/images/jpg/go-ers/testimonial/GOER-Djimi.svg";
import testmoni2 from "public/static/images/jpg/go-ers/testimonial/GOER-Incentives-Charles.svg";
import testmoni3 from "public/static/images/jpg/go-ers/testimonial/GOER-Mirnawati.svg";

export const DataTestimonialGoErs = [
  {
    name: "Djimi Susanto",
    message:
      "Edukasi produk yang diberikan Tim Home Credit GO! serta dukungan dari toko membuat saya lebih enjoy sebagai Sobat Goer dan tantangan untuk meyakinkan pelanggan pun terasa lebih ringan!",
    img: testmoni1,
    title: "Bekasi",
  },
  {
    name: "Mirnawati",
    message:
      "Menjadi Sobat Goer tidak pernah membebani saya. Karena bisa dapetin penghasilan tambahan dan pelanggan baru juga. Pendekatan yang tepat saat menawarkan promo menjadi cara saya meyakinkan teman/keluarga.",
    img: testmoni2,
    title: "Batam",
  },
  {
    name: "Charles Winokan",
    message:
      "Bisa dapetin penghasilan tambahan semudah referensiin pelanggan buat datang ke toko menjadi keuntungan yang saya rasakan sebagai Sobat Goer. Apalagi ada media sosial yang bikin berbagi info promo jadi lebih mudah!",
    img: testmoni3,
    title: "Manado",
  },
];
